import { ref } from 'vue';
import { ApprovalQuery } from '@/services/api/resources/approval/query';
import { useTask } from '@/ui/concerns';
import { list as getApprovalList } from '@/services/api/resources/approval';
import { sequence } from '@/ui/helpers';

export const useApprovalCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const approvalQuery = (): ApprovalQuery => ({
    page: 1,
    perPage: 1,
    sort: '',
    dir: '',
    search: '',
    doneBy: [],
    approvers: [],
    status: [],
    type: [],
    updatedAtStart: null,
    updatedAtEnd: null,
  });

  const performCheck = useTask(
    () => sequence(
      getApprovalList(approvalQuery()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
